"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('span', {
    staticClass: "sk-circle-spinner",
    style: _vm._px2rem(_vm.spinnerStyle, 24, []),
    attrs: {}
  }, [_c('span', {
    staticClass: "sk-circle-spinner__circle sk-circle-spinner__circle--1",
    style: _vm._px2rem(_vm.circle1Style, 24, []),
    attrs: {}
  }), _vm._v(" "), _c('span', {
    staticClass: "sk-circle-spinner__circle sk-circle-spinner__circle--2",
    style: _vm._px2rem(_vm.circle2Style, 24, []),
    attrs: {}
  })]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'SkHalfCircleSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 1000
    },
    size: {
      type: Number,
      "default": 30
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: "".concat(this.size, "px"),
        width: "".concat(this.size, "px"),
        textAlign: 'left'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: "".concat(this.size / 10, "px"),
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    },
    circle1Style: function circle1Style() {
      return Object.assign({}, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return Object.assign({}, this.circleStyle);
    }
  }
};
exports["default"] = _default;